import { useEffect } from "react";
import { useRecoilState } from "recoil";

import { configState } from "./state";
import { DEFAULT_CONFIG } from "@/utils/config";

const useConfig = (accessToken?: string) => {
  const [config, setConfig] = useRecoilState(configState);
  const language = navigator.language || "en-US";

  useEffect(() => {
    setConfig(DEFAULT_CONFIG as any);

    if (!accessToken) {
      // console.log("unauthorized");
    }
  }, []);

  return { config, error: null, isLoading: false, language };
};

export { useConfig };
